import _isObject from 'lodash/isObject';
import _isEqual from 'lodash/isEqual';

export default function areObjectsEqual(obj1, obj2) {
  if (!(_isObject(obj1) && _isObject(obj2))) return false;

  return JSON.stringify(obj1) === JSON.stringify(obj2) || _isEqual(obj1, obj2);
}
